// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"0734b837","544":"0734b837","724":"1ffeb6a7"}[chunkId] + ".chunk.css";
};